import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

interface SlideUpPageProps {
  children: React.ReactNode;
  onClose?: () => void;
  showCloseButton?: boolean;
}

export function SlideUpPage({ children, onClose, showCloseButton = true }: SlideUpPageProps) {
  const navigate = useNavigate();
  const [isExiting, setIsExiting] = useState(false);
  const [isEntered, setIsEntered] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    requestAnimationFrame(() => {
      setIsEntered(true);
    });
  }, []);

  const handleClose = useCallback(() => {
    setIsExiting(true);
    
    // Wait for exit animation to complete before navigating
    setTimeout(() => {
      if (onClose) {
        onClose();
      } else {
        navigate(-1);
      }
    }, 350); // Match the slideDownOut animation duration
  }, [onClose, navigate]);

  return (
    <div
      className={`fixed inset-0 z-50 ${isEntered && !isExiting ? 'slide-up-enter' : ''} ${isExiting ? 'slide-down-exit' : ''}`}
      style={{
        backgroundColor: 'var(--color-bg-primary)',
        opacity: isEntered ? 1 : 0,
        transform: isEntered && !isExiting ? 'translateY(0)' : 'translateY(100%)',
      }}
    >
      {/* Close button */}
      {showCloseButton && (
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full transition-all duration-200 active:scale-95"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            marginTop: 'env(safe-area-inset-top, 0px)',
          }}
          aria-label="Lukk"
        >
          <X className="w-6 h-6" style={{ color: 'var(--color-text-primary)' }} />
        </button>
      )}

      {/* Content */}
      <div 
        className="h-full overflow-auto"
        style={{
          paddingTop: 'env(safe-area-inset-top, 0px)',
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        {children}
      </div>
    </div>
  );
}





